import { useCallback, useContext, useMemo, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { AppGeneralContext } from '../../../shared/GeneralContext/GeneralContext'
import { ToggleMenu } from '../../atoms'
import Chat from '../../atoms/iconsComponent/Chat'
import Invoice from '../../atoms/iconsComponent/Invoice'
import User from '../../atoms/iconsComponent/User'
import { LoginType } from '../../types/Context'
import './BottomBarMenu.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronRight } from '@fortawesome/free-solid-svg-icons'
import { useAuth } from 'shared/auth'

export const BottomBarMenu = () => {
    const { menuIsOpen, setMenuIsOpen, loginType } = useContext(AppGeneralContext)
    const navigate = useNavigate()
    const location = useLocation()
    const [showFullMenu, setShowFullMenu] = useState(false)
    const {auth} = useAuth()


    const goToBillings = () => {
        if (location.pathname.toLowerCase().includes("start-up/profile/billings")) {
            navigate("start-up/profile")
            setMenuIsOpen(false)
        } else {
            navigate("start-up/profile/billings")
            setMenuIsOpen(false)
        }
    }

    const goToChat = () => {
        const route = loginType === LoginType.startup ? "start-up" : "corporate"
        if (location.pathname.toLowerCase().includes(`${route}/profile/messaging`)) {
            navigate("start-up/profile")
            setMenuIsOpen(false)
        } else {
            navigate(`${route}/profile/messaging`)
            setMenuIsOpen(false)
        }
    }

    const goToEdit = () => {
        const route = loginType === LoginType.startup ? "start-up" : "corporate"

        if (location.pathname.toLowerCase().includes(`${route}/edit-profile`)) {
            navigate("start-up/profile")
            setMenuIsOpen(false)
        } else {
            navigate(`${route}/edit-profile`)
            setMenuIsOpen(false)
        }
    }



    const handleMenuToggle = useCallback(() => {
        // if (menuIsOpen) {
        setMenuIsOpen(!menuIsOpen)
        // } else {
        //     setShowFullMenu(false)
        // }

    }, [menuIsOpen])


    const menu = useMemo(()=>{
        if(!auth?.jwtToken){
            return null
        }

        if(showFullMenu){
            return(
                <div className="container-fluid bar_menu_cont p-0 m-0 d-flex justify-content-center align-items-center">
                    <div className='bar_menu d-flex m-1 m-md-3 flex-row justify-content-between'>

                        <div className={"toggle_cont m-1 m-md-3 white-icon"} onClick={() => { setShowFullMenu(false) }}>
                            <FontAwesomeIcon color='white' icon={faChevronRight} />
                        </div>
                        <ToggleMenu
                            isOpen={menuIsOpen}
                            className='m-1 m-md-3  white-icon'
                            onClick={() => handleMenuToggle()}
                        />
                        {loginType === LoginType.startup && <div className={"toggle_cont m-1 m-md-3 white-icon"} onClick={() => { goToBillings() }}>
                            <Invoice className='p-1' />
                        </div>}
                        <div className={"toggle_cont m-1 m-md-3 white-icon"} onClick={() => { goToChat() }}>
                            <Chat className='p-1' />
                        </div>
                        <div className={"toggle_cont m-1 m-md-3 white-icon"} onClick={() => { goToEdit() }}>
                            <User className='p-1' />
                        </div>
                    </div >
                </div >
            )
        }

        return(
            <div className="bar_menu_cont_mobile p-0 m-0 d-flex justify-content-center align-items-center">
                    <div className='bar_menu d-flex m-1 m-md-3 flex-row justify-content-between w-100'>
                        <ToggleMenu
                            isOpen={menuIsOpen}
                            className='m-1 m-md-3 white-icon'
                            onClick={() => { setShowFullMenu(true) }}
                        />
                    </div >
                </div >
        )


    },[auth?.jwtToken,showFullMenu,menuIsOpen,loginType])


    return menu 
}